import "@/assets/styles/main.scss"
import "@/assets/styles/font-awesome.scss"

import "@/library/extensions/array"
import "@/library/extensions/string"

import React, {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import RootComponent from "@/root"
import AuthProvider from "@/library/auth/auth-provider"
import ToastProvider from "@/library/toasts/toast-provider"

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <AuthProvider>
            <ToastProvider>
                <RootComponent/>
            </ToastProvider>
        </AuthProvider>
    </StrictMode>,
)
